// ABOUTME: Creates the "Custom work order fields" menu item for the navbar.
// ABOUTME: Links to PackManager when custom fields exist, otherwise shows a disabled tooltip.

import { useQuery } from "@apollo/client/react";
import { Icon, Tooltip } from "@nulogy/components";
import { GetCustomWorkOrderFields } from "hooks/apollo/customWorkOrderField/customWorkOrderFields.gql";
import Codenames from "policies/Codenames";
import React from "react";
import styled from "styled-components";

export function customWorkOrderFieldsMenuItem({ applicationContext }) {
  const { packmanagerUrl } = applicationContext;

  return {
    name: "Custom work order fields",
    render: () => <CustomWorkOrderFieldsMenuItem packmanagerUrl={packmanagerUrl} />,
  };
}

function CustomWorkOrderFieldsMenuItem({ packmanagerUrl }) {
  const { data, loading } = useQuery(GetCustomWorkOrderFields);
  const hasCustomWorkOrderFields = data?.customWorkOrderFields?.length > 0;

  if (loading) {
    return <DisabledMenuItem>Custom work order fields</DisabledMenuItem>;
  }

  if (hasCustomWorkOrderFields) {
    const href = `${packmanagerUrl}/custom_work_order_fields`;
    return (
      <NavBarLink href={href} rel="noopener noreferrer" target="_blank">
        Custom work order fields
        <Icon icon="openInNew" size="x2" />
      </NavBarLink>
    );
  }

  return <CustomWorkOrderFieldsDisabled />;
}

function CustomWorkOrderFieldsDisabled() {
  return (
    <Tooltip tooltip={DISABLED_TOOLTIP_TEXT}>
      <DisabledMenuItem>Custom work order fields</DisabledMenuItem>
    </Tooltip>
  );
}

const DISABLED_TOOLTIP_TEXT = `Custom work order fields cannot be configured until ${Codenames.Packmanager} site and account UUIDs have been specified for the Production Scheduling site.`;

const DisabledMenuItem = styled.span(({ theme }) => ({
  color: theme.colors.grey,
  cursor: "not-allowed",
  display: "block",
  fontSize: theme.fontSizes.medium,
  fontWeight: theme.fontWeights.medium,
  lineHeight: theme.lineHeights.base,
  padding: `${theme.space.x1} ${theme.space.x2}`,
}));

// Styled to match NavBarButton in ApplicationNavBar.jsx
const NavBarLink = styled.a(({ theme }) => ({
  "&:focus": {
    boxShadow: theme.shadows.focus,
  },
  "&:hover, &:focus": {
    backgroundColor: theme.colors.whiteGrey,
    color: theme.colors.darkBlue,
    cursor: "pointer",
    outline: "none",
  },
  alignItems: "center",
  backgroundColor: "transparent",
  borderRadius: theme.radii.medium,
  color: theme.colors.darkGrey,
  display: "flex",
  fontSize: theme.fontSizes.medium,
  fontWeight: theme.fontWeights.medium,
  gap: "4px",
  lineHeight: theme.lineHeights.base,
  padding: `${theme.space.x1} ${theme.space.x2}`,
  textDecoration: "none",
  transition: ".2s",
}));
